import React from 'react';
import { Box } from '@mui/material';

const ChartCard: React.FC<{
    title: string;
    brand: string;
    children: React.ReactNode;
}> = ({ title, brand, children }) => (
    <Box
        pt={2}
        sx={{
            display: 'flex',
            flexDirection: 'column',
            height: 480,
        }}
    >
        <Box sx={{ display: 'flex', mb: 2 }}>
            <Box
                sx={{
                    bgcolor: brand,
                    color: '#fff',
                    fontWeight: 800,
                    px: 3,
                    py: 1,
                    borderRadius: 2, // pill
                    lineHeight: 1,
                    textAlign: 'center',
                    boxShadow: '0 1px 0 rgba(0,0,0,0.12)',
                }}
            >
                {title}
            </Box>
        </Box>

        {/* chart goes here */}
        <Box sx={{ flex: 1, minHeight: 0 }}>{children}</Box>
    </Box>
);

export default ChartCard;
